// extracted by mini-css-extract-plugin
module.exports = {"infoText":"AccountDelete_infoText__G1EGF"};